export const PartnersFormSubmitted = () => {
    pushToDataLayer({
        event: 'formularz_program_partnerski',
    })
}

export const ContactFormSubmitted = (responseData, formData) => {
    pushToDataLayer({
        event: 'contact_form_submitted',
        ticketId: responseData?.ticketId,
        customer: {
            name: formData.get('name'),
            surname: formData.get('surname'),
            email: formData.get('email'),
        },
    })
}

export const PresentationFormSubmitted = (responseData, formData) => {
    pushToDataLayer({
        event: 'form_introduction',
        ticketId: responseData?.ticketId,
        customer: {
            name: formData.get('name'),
            surname: formData.get('surname'),
            email: formData.get('email'),
            phone: formData.get('phone'),
            company: formData.get('company'),
            www: formData.get('www'),
            employees: formData.get('employees'),
        },
    })
}

export const DemoFormSubmitted = (responseData, formData) => {
    pushToDataLayer({
        event: 'system_registration',
        ticketId: responseData?.ticketId,
        customer: {
            name: formData.get('name'),
            surname: formData.get('surname'),
            email: formData.get('email'),
            phone: formData.get('phone'),
            company: formData.get('company'),
            www: formData.get('www'),
            employees: formData.get('employees'),
        },
    })
}

export const EbookFormSubmitted = (name) => () => {
    pushToDataLayer({
        event: 'ebook_downloaded',
        name: name,
    })
}

export const CallbackCreated = () => {
    pushToDataLayer({
        event: 'call_widget_started',
    })
}

export const ConversationStarted = () => {
    pushToDataLayer({
        event: 'chat_start',
    })
}

const pushToDataLayer = (options) => {
    if (window.dataLayer) {
        window.dataLayer.push(options)
    }
}
